import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import PhoneNumberInput from './PhoneNumberInput';
import useFormName from '../../../../../../Hooks/useFormName';
import ErrorMessage from '../ErrorMessage';
import TopFieldContent from '../TopFieldContent';

interface PhoneNumberFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (phoneNumber: string) => void;
	disabled?: boolean;
	placeholder?: string;
}

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
	name,
	label,
	className,
	isRequired,
	disabled,
	placeholder,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<PhoneNumberInput
				{...field}
				disabled={disabled}
				placeholder={placeholder}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default PhoneNumberField;
